<template>
  <div>
    <div v-if="project != null" class="project-container animated fadeIn">
      <!-- container-fluid -->
      <div v-show="printViewHidden && warningsViewHidden && geometryDetailsViewHidden" class="row">
        <!-- v-if="printViewHidden && designStateHidden && warningsViewHidden" -->
        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        <div
          v-if="
            shoulderPresent &&
              isInManagement == false /* && !(selectionView || selectionOutputView) */
          "
          class="col-xl-3 col-lg-12"
        >
          <keep-alive>
            <component
              :is="shoulderComponent"
              :parent-path="project.path"
              :local-path="'.shoulder'"
              @setSelection="impostaMascheraSelezione"
              @setVerify="calcModeToggle('verify')"
            ></component>
          </keep-alive>
        </div>
        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        <div :class="{ 'col-xl-9': shoulderPresent, 'col-lg-12': shoulderPresent }">
          <div class="row">
            <div class="col-12">
              <keep-alive>
                <component
                  :is="topComponent"
                  :parent-path="project.path"
                  :local-path="'.top'"
                ></component>
              </keep-alive>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-12" style="margin-bottom: 24px;">
              <keep-alive>
                <component
                  :is="leftComponent"
                  :parent-path="project.path"
                  :local-path="'.left'"
                ></component>
              </keep-alive>
            </div>
            <div class="col-xl-6 col-lg-12" style="margin-bottom: 24px;">
              <keep-alive>
                <component
                  :is="rightComponent"
                  :parent-path="project.path"
                  :local-path="'.right'"
                ></component>
              </keep-alive>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <keep-alive>
                <component
                  :is="bottomComponent"
                  v-if="verifyView"
                  :parent-path="project.path"
                  :local-path="'.bottom'"
                ></component>
              </keep-alive>
              <keep-alive>
                <component
                  :is="bottomDesignComponent"
                  v-if="designView"
                  :parent-path="project.path"
                  :local-path="'.bottomDesign'"
                ></component>
              </keep-alive>
              <keep-alive>
                <component
                  :is="bottomSelectionComponent"
                  v-if="selectionView"
                  :parent-path="project.path"
                  :local-path="'.bottomSelection'"
                ></component>
              </keep-alive>
              <keep-alive>
                <component
                  :is="outputSelectionComponent"
                  v-if="selectionOutputView"
                  ref="selectionOutput"
                  :parent-path="project.path"
                  :local-path="'.selectionOutput'"
                  @passaInVerifica="passaInVerifica"
                ></component>
              </keep-alive>
            </div>
          </div>
        </div>
      </div>
      <!-- <vue-friendly-iframe v-if="printView" src="/UnilabReport/ReportView/ReportViewerView"
      scrolling="no" frameborder="0" style="position: relative; height: 100%; width: 100%;"></vue-friendly-iframe>-->
      <div v-if="!printViewHidden" class="row">
        <p>Print view</p>
      </div>
      <!--<div class="row" v-if="!designViewHidden">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <keep-alive>
                <component 
                    v-bind:is="designComponent" 
                    :parentPath="project.path"
                    :localPath="'.design'">
                  </component>
                </keep-alive>
            </div>
          </div>
        </div>
      </div>-->
      <b-modal
        v-model="showWarnings"
        size="xl"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        hide-header
      >
        <div class="row">
          <div class="col-12">
            <keep-alive>
              <WarningsPanel
                :parent-path="project.path"
                :local-path="'.shoulder'"
                :warnings="warningsList"
              ></WarningsPanel>
            </keep-alive>
          </div>
        </div>
        <div class="row" style="padding-right: 20px; text-align: right;">
          <div class="col-12">
            <!-- TERMINA_CALCOLO: chiude la modale senza calcolare -->
            <b-button
              squared
              variant="success"
              @click="
                {
                  showWarnings = false;
                }
              "
              >{{ uniTranslation("TRNSL267") }}</b-button
            >
            <!-- CONTINUA_CALCOLO: solo per i warning non bloccanti
                 che richiedono conferma (AskToContinue) -->
            <b-button
              v-show="bAskToContinue"
              squared
              variant="success"
              style="margin-left: 10px;"
              @click="eseguiCalcolo()"
              >{{ uniTranslation("TRNSL266") }}</b-button
            >
          </div>
        </div>
      </b-modal>

      <div v-if="!geometryDetailsViewHidden" class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <keep-alive>
                <GeometryDetailsPanel
                  :parent-path="project.path"
                  :local-path="'.shoulder'"
                ></GeometryDetailsPanel>
              </keep-alive>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="uniTranslation('S698')" :visible.sync="saveProjectDialogVisible">
      <el-form>
        <el-form-item :label="uniTranslation('S1080')" :label-width="'200px'">
          <el-input
            v-model="project.name"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S504')" :label-width="'200px'">
          <el-input
            v-model="project.title"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S390')" :label-width="'200px'">
          <el-input
            v-model="project.customer"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S999')" :label-width="'200px'">
          <el-input
            v-model="project.customerContact"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S184')" :label-width="'200px'">
          <el-input
            v-model="project.description"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveProjectDialogVisible = false">{{
          uniTranslation("S128")
        }}</el-button>
        <el-button type="primary" @click="saveProject">{{ uniTranslation("S198") }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="uniTranslation('S104')" :visible.sync="saveProjectAndPrintDialogVisible">
      <el-form>
        <el-form-item v-show="false" :label="uniTranslation('S1080')" :label-width="'200px'">
          <el-input
            v-model="project.name"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S504')" :label-width="'200px'">
          <el-input
            v-model="project.title"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S390')" :label-width="'200px'">
          <el-input
            v-model="project.customer"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S999')" :label-width="'200px'">
          <el-input
            v-model="project.customerContact"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
        <el-form-item :label="uniTranslation('S184')" :label-width="'200px'">
          <el-input
            v-model="project.description"
            autocomplete="off"
            @keyup.enter="saveProject()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveProjectAndPrintDialogVisible = false">{{
          uniTranslation("S128")
        }}</el-button>
        <el-button type="primary" @click="saveProjectAndPrint">{{
          uniTranslation("S198")
        }}</el-button>
      </span>
    </el-dialog>
    <div
      v-if="isLoading == false"
      class="project-footer"
      :style="{
        backgroundColor: coloreFooterSfondo,
        color: coloreFooterTesto,
        borderColor: coloreBordo
      }"
      style="z-index:1018"
    >
      <div class="main">
        <b-row style="overflow: hidden">
          <b-col cols="2">
            <a href="https://www.unilab.eu/it/" style="color: gray" target="blank"
              >Powered by Unilab SRL</a
            >
          </b-col>
          <b-col cols="10">
            <button
              v-if="(bHasWarnings || bHasBlockingWarnings) && isInManagement == false"
              v-tooltip="{
                content: uniToolTipTranslation('S954', 'en-US'),
                placement: 'right'
              }"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              type="button"
              class="btn-print-project btn btn-default"
              @click="
                {
                  showWarnings = true;
                }
              "
            >
              <i class="fa fa-warning"></i>
              {{ uniTranslation("S954") }}
            </button>
            <button
              v-show="calculated && verifyView && isInManagement == false"
              v-tooltip="{ content: uniToolTipTranslation('S104', 'en-US'), placement: 'left' }"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              type="button"
              class="btn btn-default pull-right"
              @click="bShowModalePreStampa = true"
            >
              <i class="fa fa-print"></i>
              {{ uniTranslation("S104") }}
            </button>
            <button
              v-show="isInManagement == false"
              v-tooltip="{ content: uniToolTipTranslation('S102', 'en-US'), placement: 'top' }"
              :disabled="bloccaCalcolo == true"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              type="button"
              class="btn btn-default pull-right"
              @click="recalculateProject"
            >
              <i :class="calcIcon"></i>
              {{ uniTranslation("TRNSL43") }}
            </button>
            <button
              v-show="isInManagement == true"
              v-tooltip="{ content: uniToolTipTranslation('TRNSL247', 'en-US'), placement: 'top' }"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              type="button"
              class="btn btn-default pull-right"
              @click="saveDefaultValues"
            >
              <i class="fa-regular fa-floppy-disk"></i>
              {{ uniTranslation("TRNSL247") }}
            </button>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-modal
      id="modal-chart"
      :title="uniTranslation('GF45')"
      size="xl"
      :ok-title="uniTranslation('PHE16')"
      :cancel-title="uniTranslation('PHE801')"
      @ok="handleChartButton"
    >
      <Grafici ref="chart" :project-id="project.projectId"></Grafici>
    </b-modal>

    <b-modal
      v-model="bBloccaCalcolo"
      size="lg"
      :ok-title="uniTranslation('OK')"
      centered
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <b-row>
        <b-col style="text-align: center;">
          <h3>
            <b>{{ uniTranslation("TRNSL258") }}</b>
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center;">
          {{ uniTranslation("TRNSL257") }}
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col></b-col>
        <b-col cols="2" md="2" lg="2" xl="2">
          <b-button block variant="success" @click="closeWarningModal">
            <i class="fa-solid fa-check"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-model="bShowModalePreStampa"
      size="md"
      centered
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <b-row>
        <b-col cols="4" md="4" lg="4" xl="4">
          <span>
            {{ uniTranslation("TRNSL260") }}
          </span>
        </b-col>
        <b-col cols="8" md="8" lg="8" xl="8">
          <el-input v-model="project.title"></el-input>
        </b-col>
      </b-row>
      <b-row>
        <br />
        <b-col v-if="bMostraWarningGeometria" cols="12" md="12" lg="12" xl="12">
          <span style="color:red">
            <b>
              <u>
                {{ uniTranslation(warningGeometria) }}
              </u>
            </b>
          </span>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col></b-col>
        <b-col cols="2" md="2" lg="2" xl="2">
          <b-button
            block
            :style="{
              backgroundColor: coloreFooterBottoni,
              borderColor: coloreBordoBottoni,
              color: coloreTestoBottoni
            }"
            @click="printProject"
          >
            <i class="fa-solid fa-check"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<!-- UnilabReport/ReportView/ReportViewerView -->

<script>
import Cookies from "js-cookie";
import store from "../../store";
import { mapActions, mapGetters } from "vuex";
import { Notification /*, Message*/ } from "element-ui";
import { Dialog, Form, FormItem, Input, Button } from "element-ui";
import { MessageBox } from "element-ui";

// import { api } from "../../gateways/unilabApi";

import VueFriendlyIframe from "vue-friendly-iframe";

import CapacityDetails from "../../components/project/CapacityDetails.vue";
import CondensingDetails from "../../components/project/CondensingDetails.vue";
import PartialCondensingDetails from "../../components/project/PartialCondensingDetails.vue";
import AirSideDetails from "../../components/project/AirSideDetails.vue";
import DirectExpansionDetails from "../../components/project/DirectExpansionDetails.vue";
import MonoPhaseDetails from "../../components/project/MonoPhaseDetails.vue";
import PumpEvaporatorDetails from "../../components/project/PumpEvaporatorDetails.vue";
import SteamDetails from "../../components/project/SteamDetails.vue";
import CoilsProjectDetails from "../../components/project/CoilsProjectDetails.vue";
import CoilsProjectAdvancedDetails from "../../components/project/CoilsProjectAdvancedDetails.vue";
import CoilsDesignDetails from "../../components/project/CoilsDesignDetails.vue";
import MonoPhasePheDetails from "../../components/project/MonoPhasePheDetails.vue";

import PheProjectDetails from "../../components/project/PheProjectDetails.vue";
import PheProjectAdvancedDetails from "../../components/project/PheProjectAdvancedDetails.vue";
import PheProjectSelectionDetails from "../../components/project/PheProjectSelectionDetails.vue";
import PheProjectAdvancedSelectionDetails from "../../components/project/PheProjectAdvancedSelectionDetails.vue";
import PheProjectSelectionOutput from "../../components/project/PheProjectSelectionOutput.vue";
import Grafici from "../../components/project/Grafici.vue";

import WarningsPanel from "../../components/shared/WarningsPanel.vue";

//import projectService from "../../services/backend/projectService";

import GeometryDetailsPanel from "../../components/project/GeometryDetails.vue";

String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};

export default {
  components: {
    VueFriendlyIframe,
    CapacityDetails,
    AirSideDetails,
    MonoPhaseDetails,
    DirectExpansionDetails,
    CondensingDetails,
    PartialCondensingDetails,
    PumpEvaporatorDetails,
    SteamDetails,
    CoilsProjectDetails,
    CoilsProjectAdvancedDetails,
    PheProjectDetails,
    PheProjectAdvancedDetails,
    PheProjectSelectionDetails,
    PheProjectAdvancedSelectionDetails,
    PheProjectSelectionOutput,
    WarningsPanel,
    CoilsDesignDetails,
    MessageBox,
    MonoPhasePheDetails,
    "el-dialog": Dialog,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input,
    "el-button": Button,
    GeometryDetailsPanel,
    Grafici
  },
  props: {},
  data() {
    return {
      calcIcon: "fa fa-calculator",
      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      coloreBordo: "",
      isOpen: false,
      project: {
        name: "",
        projectId: "",
        type: null,
        panels: null,
        modality: 0,
        path: "",
        title: "",
        description: ""
      },
      calculated: false,
      printView: false,
      verifyView: true,
      designView: false,
      selectionView: false,
      selectionOutputView: false,
      warningsView: false,
      topComponent: "",
      leftComponent: "",
      rightComponent: "",
      bottomComponent: "",
      bottomDesignComponent: "",
      bottomSelectionComponent: "",
      outputSelectionComponent: "",
      shoulderComponent: "",
      shoulderDesignComponent: "",
      shoulderSelectionComponent: "",
      bHasWarnings: false,
      bHasBlockingWarnings: false,
      bAskToContinue: false,
      warningsList: [],
      saveProjectDialogVisible: false,
      saveProjectAndPrintDialogVisible: false,
      shoulderPresent: true,
      unsubscribes: [],
      defaultValues: {},
      showWarnings: false,
      bBloccaCalcolo: false,
      bShowModalePreStampa: false,
      warningGeometria: "",
    };
  },
  computed: {
    ...mapGetters("_prjModule", [
      "projects",
      "currentProject",
      "isSaldobrasata",
      "defValues",
      "bloccaCalcolo"
    ]),
    ...mapGetters("_colorsModule", ["footerColors"]),
    ...mapGetters("_commonModule", ["isLoading", "isInManagement"]),
    ...mapGetters("_translationModule", ["currentLanguage"]),
    ...mapGetters("_authModule", ["bShowTranslationsId"]),
    saved() {
      var that = this;
      let prj = that.projects[that.project.projectId];
      if (prj == undefined || prj == null) return false;
      return prj.saved;
    },
    sidebarVisible() {
      return !this.$store.getters.sidebar;
    },
    sideMenuHidden() {
      return this.$store.getters.asideMenu;
    },
    printViewHidden() {
      return this.$store.getters.printViewHidden;
    },
    warningsViewHidden() {
      return this.$store.getters.warningsViewHidden;
    },
    geometryDetailsViewHidden() {
      return this.$store.getters.geometryDetailsViewHidden;
    },
    bMostraWarningGeometria() {
      let prj = this.projects[this.currentProject];
      let bMostra = false;

      if (prj != null && prj != undefined) {
        let inner = prj.innerProject;

        if (inner != null && inner != undefined) {
          let geom = inner.datiCostruttivi.geometria;
          if (geom != null && geom != undefined) {
            if(inner.datiCostruttivi.geometria.codice.toUpperCase().endsWith("L")){
              bMostra = true;
              this.warningGeometria = "TRNSL262";
            }
            if(inner.datiCostruttivi.geometria.codice.toUpperCase().endsWith("M")){
              bMostra = true;
              this.warningGeometria = "TRNSL263";
            }
          }
        }
      }

      return bMostra;
    }
  },
  watch: {
    footerColors() {
      this.setColors();
    },
    sidebarHidden: function(/*nv, ov*/) {
      var that = this;
      setTimeout(that.handleScroll, 275);
    },
    sideMenuHidden: function(/*nv, ov*/) {
      var that = this;
      setTimeout(that.handleScroll, 275);
    },
    bloccaCalcolo: function() {
      if (this.bloccaCalcolo == true) {
        this.bBloccaCalcolo = true;
      }
    }
  },
  created() {},
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted() {
    var that = this;

    that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });

    this.setVerifica(true);
    that.setColors();

    var modality = that.projects[that.currentProject].modality;
    var payload = {};
    payload.modality = modality;
    payload.projectId = that.currentProject;
    that.open(payload).then(function(data) {
      that.defaults().then(json => {
        that.defaultValues = json != "" ? JSON.parse(json) : {};
        that.saveDefValuesInStore(JSON.parse(JSON.stringify(that.defaultValues))).then(() => {
          var prj = JSON.parse(JSON.stringify(data));
          if (data.saved == false) {
            prj = that.setDefaltValues(that.defaultValues, data);
          }
          that.load({
            projectId: prj.projectId,
            project: prj
          });
          that.initProj(prj);
        });
      });
    });

    that.$nextTick(function() {
      /*setTimeout(function() {
        that.handleScroll(null, true);
      }, 251);*/

      that.unsubscribes.push(
        that.$store.subscribe(function(mutation /*, state*/) {
          if (mutation.type === "refreshWarnings") {
            that.impostaWarning();
          }
        })
      );
    });
  },
  methods: {
    ...mapActions("_colorsModule", ["getColoriFooterAction"]),
    ...mapActions("_prjModule", [
      "create",
      "load",
      "clear",
      "update",
      "remove",
      "save",
      "calculate",
      "checkWarningSeContinuarePreCalcolo",
      "setVerifica",
      "setSelezione",
      "setResults",
      "changeProperty",
      "setDefaults",
      "defaults",
      "open",
      "saveDefValuesInStore"
    ]),
    ...mapActions("_commonModule", ["setLoading", "setPrintoutLink"]),
    setColors() {
      var that = this;

      that.coloriFooter = that.footerColors; // 3 elementi 0=sfondo 1=testo 2=bottoni
      that.coloreFooterSfondo = that.footerColors[0];
      that.coloreFooterTesto = that.footerColors[1];
      that.coloreFooterBottoni = that.footerColors[2] + " !important";
      that.coloreTestoBottoni = that.footerColors[3];
      that.coloreBordoBottoni = that.footerColors[4];
      that.coloreBordo = that.footerColors[5];
    },
    setDefaltValues: function(def, prj) {
      var that = this;

      var ramo = that.isSaldobrasata ? "brz" : "isp";

      if (def[ramo] == undefined) {
        return prj;
      }

      prj.bottom = def[ramo].bottom;
      prj.right = def[ramo].right;
      prj.left = def[ramo].left;
      prj.top = def[ramo].top;
      prj.shoulder = def[ramo].shoulder;
      prj.bottomSelection = def[ramo].bottomSelection;
      prj.bottomSelection.saldobrasata = that.isSaldobrasata;
      return prj;
    },
    saveDefaultValues: function() {
      var that = this;
      var values = that.getNuoviDefaultValues();

      that.setLoading({ bool: true, icon: "fa-regular fa-floppy-disk fa-5x" });
      that.setDefaults(values).then(() => {
        that.setLoading({ bool: false, icon: "fa-regular fa-floppy-disk fa-5x" });
      });
    },
    getNuoviDefaultValues() {
      var that = this;

      var ramo = that.isSaldobrasata ? "brz" : "isp";

      var prj = that.projects[that.currentProject];

      that.defaultValues[ramo] = {};
      that.defaultValues[ramo].bottom = prj.bottom;
      that.defaultValues[ramo].right = prj.right;
      that.defaultValues[ramo].left = prj.left;
      that.defaultValues[ramo].top = prj.top;
      that.defaultValues[ramo].shoulder = prj.shoulder;
      that.defaultValues[ramo].bottomSelection = prj.bottomSelection;

      return that.defaultValues;
    },
    closeWarningModal() {
      this.bBloccaCalcolo = false;
    },
    handleChartButton: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.chart.generateChart();
    },
    impostaWarning() {
      var that = this;
      let prj = that.projects[that.project.projectId];

      if (prj == undefined || prj == null) {
        return;
      }

      if (prj.innerProject != null) {
        that.bHasWarnings = prj.innerProject.hasWarnings; //jsonHelper.getProperty(that.projects, ""); //true; //
        that.bHasBlockingWarnings =
          prj.innerProject.hasWarningsBloccantiPreCalcolo ||
          prj.innerProject.hasWarningsBloccantiPostCalcolo;
        // bAskToContinue viene acceso SOLO dal controllo pre-calcolo
        // (recalculateProject): qui siamo a calcolo fatto, il bottone
        // "continua" non deve comparire nella modale dei warning post-calcolo
        that.bAskToContinue = false;
        that.warningsList = prj.innerProject.warnings;

        that.showWarnings = that.bHasBlockingWarnings;
      } else {
        that.bHasWarnings = false;
        that.bHasBlockingWarnings = false;
        that.bAskToContinue = false;
        that.warningsList = [];
      }
    },
    impostaMascheraSelezione() {
      var that = this;

      that.calculated = false;
      that.calcModeToggle("selection");

      that.setSelezione(true);
      /*var prj = that.projects[that.currentProject];
      if (prj != null) {
        console.log(prj);
        if (prj.selectionOutput.selectionOutput.length > 0) {
          that.setResults(prj.selectionOutput).then(function() {
            var polling = setInterval(() => {
              if (that.$refs.selectionOutput) {
                that.$refs.selectionOutput.popolaGriglia();
                clearInterval(polling);
              }
            }, 100);
          });
          that.subViewToggle("toggleSelectionOutputViewProperty");
        }
      }*/
    },
    passaInVerifica() {
      var that = this;

      that.setVerifica(true);
      that.calcModeToggle("verify");
      that.recalculateProject();
    },
    initProj(res) {
      this.isOpen = false;
      this.project = {
        name: "",
        projectId: "",
        type: null,
        panels: null,
        modality: 0,
        path: "",
        title: "",
        description: ""
      };
      this.calculated = false;
      this.printView = false;
      this.verifyView = res.performDesign === false && res.performSelection === false;
      this.designView = res.performDesign;
      this.selectionView = res.performSelection;
      this.warningsView = false;
      this.topComponent = "";
      this.leftComponent = "";
      this.rightComponent = "";
      this.bottomComponent = "";
      this.bottomDesignComponent = "";
      this.bottomSelectionComponent = "";
      this.outputSelectionComponent = "";
      this.shoulderComponent = "";
      this.shoulderDesignComponent = "";
      this.shoulderSelectionComponent = "";
      this.bHasWarnings = false;
      this.bHasBlockingWarnings = false;
      this.warningsList = [];
      this.saveProjectDialogVisible = false;
      this.saveProjectAndPrintDialogVisible = false;
      this.topComponent = res.panels.top;
      this.leftComponent = res.panels.left;
      this.rightComponent = res.panels.right;
      this.bottomComponent = res.panels.bottom;
      this.bottomDesignComponent = res.panels.bottomDesign;
      this.bottomSelectionComponent = res.panels.bottomSelection;
      this.outputSelectionComponent = res.panels.outputSelection;
      this.shoulderComponent = res.panels.shoulder;
      this.shoulderDesignComponent = res.panels.shoulderDesign;
      this.shoulderSelectionComponent = res.panels.shoulderSelection;
      this.project = {
        name: res.name,
        projectId: res.projectId,
        type: res.type,
        panels: res.panels,
        modality: res.modality,
        path: res.projectId,
        title: res.title,
        description: res.description
      };
      //this.$store.dispatch("disableProfile");
      //this.$store.dispatch("resetSubViews");
      //this.$store.dispatch("changeActiveProjectModalityProperty", res.modality);
      if (res.performSelection) {
        this.shoulderPresent = true; //false; 07/10/19
      }
      if (res.performDesign) {
        // TODO LUCA
        this.$store.dispatch("toggleDesignViewProperty");
      }
      this.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
    },
    saveProject: function() {
      var that = this;
      that.changeProperty({
        path: that.project.path + ".name",
        value: that.project.name
      });
      that.changeProperty({
        path: that.project.path + ".customer",
        value: that.project.customer
      });
      that.changeProperty({
        path: that.project.path + ".customerContact",
        value: that.project.customerContact
      });
      that.changeProperty({
        path: that.project.path + ".description",
        value: that.project.description
      });
      that.save(that.projects).then(function(data) {
        if (data != undefined) {
          that.saveProjectDialogVisible = false;
          Notification.success({
            title: that.uniTranslation("S698"),
            message: that.uniTranslation("S1778")
          });
          that.load({
            projectId: data.projectId,
            project: data
          });
        } else {
          Notification.error({
            title: that.uniTranslation("S1214"),
            message: that.uniTranslation("S1440")
          });
        }
      });
    },
    saveProjectAndPrint: function() {
      var that = this;
      that.changeProperty({
        path: that.project.path + ".name",
        value: that.project.name
      });
      that.changeProperty({
        path: that.project.path + ".customer",
        value: that.project.customer
      });
      that.changeProperty({
        path: that.project.path + ".customerContact",
        value: that.project.customerContact
      });
      that.changeProperty({
        path: that.project.path + ".title",
        value: that.project.title
      });
      that.changeProperty({
        path: that.project.path + ".description",
        value: that.project.description
      });
      that.save(that.projects).then(function(data) {
        if (data != undefined) {
          that.saveProjectAndPrintDialogVisible = false;
          that.load({
            projectId: data.projectId,
            project: data
          });
          setTimeout(() => {
            that.printProject();
          }, 500);
        } else {
          Notification.error({
            title: that.uniTranslation("S1214"),
            message: that.uniTranslation("S1440")
          });
        }
      });
    },
    recalculateProject: function() {
      var that = this;

      that.calcIcon = "fa fa-spinner fa-spin";
      that.calculated = false;
      that.bAskToContinue = false;

      that.changeProperty({
        path: this.project.path + ".overrideWarnings",
        value: false
      });
      that.changeProperty({
        path: this.project.path + ".currentLanguage",
        value: this.currentLanguage
      });

      // Controllo PRE-calcolo: se esistono warning non bloccanti che richiedono
      // conferma, si mostra la modale e si aspetta la scelta dell'utente.
      // Il calcolo parte solo se non ce ne sono, o dopo la conferma (eseguiCalcolo).
      that.setLoading({ bool: true, icon: "fa-solid fa-calculator fa-5x" });
      that.checkWarningSeContinuarePreCalcolo(that.projects).then(function(data) {
        if (data != null && data != undefined && data.length > 0) {
          that.warningsList = data;
          that.bAskToContinue = true;
          that.showWarnings = true;
          that.calcIcon = "fa fa-calculator";
          that.setLoading({ bool: false, icon: "fa-solid fa-calculator fa-5x" });
          return;
        }

        that.eseguiCalcolo();
      });
    },
    eseguiCalcolo: function() {
      var that = this;

      that.showWarnings = false;
      that.bAskToContinue = false;
      that.calcIcon = "fa fa-spinner fa-spin";

      that.setLoading({ bool: true, icon: "fa-solid fa-calculator fa-5x" });
      that.calculate(that.projects).then(function(data) {
        //console.log(data);
        that.calcIcon = "fa fa-calculator";
        if (data != null && data != undefined) {
          var payload = {};
          payload.projectId = data.projectId;
          payload.project = data;
          that.load(payload);

          //store.dispatch("refreshWarnings");
          that.impostaWarning(); //andrea 10.05.2022

          if (data.performSelection) {
            that.subViewToggle("toggleSelectionOutputViewProperty");
          }
          let bHasBlockingWarnings =
            data.innerProject.hasWarningsBloccantiPreCalcolo ||
            data.innerProject.hasWarningsBloccantiPostCalcolo;
          that.calculated = data.calculated && !bHasBlockingWarnings; // true;
          if (data.performSelection) {
            that.selectionOutputView = data.results.length > 0;
            data.selectionOutput.results = data.results;
            that.setResults(data.selectionOutput).then(function() {
              var polling = setInterval(() => {
                if (that.$refs.selectionOutput) {
                  that.$refs.selectionOutput.popolaGriglia();
                  clearInterval(polling);
                }
              }, 100);
            });
          }
        } else {
          alert(JSON.stringify(data));
        }

        that.setLoading({ bool: false, icon: "fa-solid fa-calculator fa-5x" });
        // ribindare i dati sul modello
        // dopo: refresh all
        /*Notification.success({
            title: "Successo",
            message: "Calcolo avvenuto con successo"
          });*/
      });
    },
    printProject: function() {
      var that = this;

      var project = that.projects;
      var prj = {};
      for (var el in project) {
        prj = project[el];
      }
      prj.saved = true;
      that.projects[that.project.path].title = that.project.title;

      that.save(that.projects).then(function(data) {
        that.load({
          projectId: data.projectId,
          project: data
        });

        //console.log(data);
        var cId = data.calculationId;
        var fn = data.title;
        var rpt = document.querySelector("#reportPath").value;

        var at = Cookies.get("loginToken");

        var routeData =
          rpt +
          "/ReportViewer/ReportViewerView?at=" +
          at +
          "&calculationId=" +
          cId +
          "&modality=" +
          prj.modality +
          "&language=" +
          that.currentLanguage +
          "&showTransId=" +
          that.bShowTranslationsId +
          "&filename=" +
          fn;

        that.setPrintoutLink(routeData);
        that.bShowModalePreStampa = false;

        that.$router.push({ name: "Printout" }).catch(() => {});
      });
    },
    calcModeToggle(mode) {
      var that = this;

      //("AAAAAAAAAAAAAAA");

      var view = "";
      var performVerify = false;
      var performDesign = false;
      var performSelection = false;
      if (mode === "verify") {
        view = "toggleVerifyViewProperty";
        this.verifyView = true;
        this.designView = false;
        this.selectionView = false;
        performVerify = true;
        performDesign = false;
        performSelection = false;
        that.setVerifica(true);
      }
      if (mode === "design") {
        view = "toggleDesignViewProperty";
        this.verifyView = false;
        this.designView = true;
        this.selectionView = false;
        performVerify = false;
        performDesign = true;
        performSelection = false;
      }
      if (mode === "selection") {
        view = "toggleSelectionViewProperty";
        this.verifyView = false;
        this.designView = false;
        this.selectionView = true;
        performVerify = false;
        performDesign = false;
        performSelection = true;
        that.setSelezione(true);
      }
      var payload = {};
      payload.path = this.project.path + ".performDesign";
      payload.value = performDesign;
      this.changeProperty(payload);
      /*this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".performDesign",
        value: performDesign
      });*/

      var payload2 = {};
      payload2.path = this.project.path + ".performSelection";
      payload2.value = performSelection;
      this.changeProperty(payload2);
      /*this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".performSelection",
        value: performSelection
      });*/
      this.subViewToggle(view);
    },
    subViewToggle(subView) {
      if (subView === "toggleVerifyViewProperty") {
        this.verifyView = true;
        this.designView = false;
        this.selectionView = false;
        this.selectionOutputView = false;
        this.shoulderPresent = true;
        return;
      }
      if (subView === "toggleDesignViewProperty") {
        this.verifyView = false;
        this.designView = true;
        this.selectionView = false;
        this.selectionOutputView = false;
        this.shoulderPresent = true;
        return;
      }
      if (subView === "toggleSelectionViewProperty") {
        this.verifyView = false;
        this.designView = false;
        this.selectionView = true;
        this.selectionOutputView = false;
        this.shoulderPresent = true; // false; // 07/10/19
        return;
      }
      if (subView === "toggleSelectionOutputViewProperty") {
        this.verifyView = false;
        this.designView = false;
        this.selectionView = true;
        this.selectionOutputView = true;
        this.shoulderPresent = true; // false; // 07/10/19
        return;
      }

      store.dispatch(subView);
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    next({
      name: "SwitchProject",
      params: {
        modality: to.params.modality,
        projectId: to.params.projectId
      }
    });
    return;
  }
  /*
  beforeRouteEnter: function(to, from, next) {
    console.log(to);
    if (to.name === "ViewProject") {

          next(vm => vm.initProj(data));

    } else {
      alert("WRONG!!");
    }
  },*/
  /*
  beforeRouteLeave: function(to, from, next) {
    let msg = "Do you really want to leave? All unsaved changes will be lost.";
    if (to.path.includes("printout")) {
      next();
    } else {
      MessageBox.confirm(msg)
        .then(() => {
          this.clear();
          next();
        })
        .catch(e => {
          console.log(e);
          next(false);
        });
    }
  }*/
};
</script>

<style lang="scss">
/*.print-container {
  width: 100%; 
  height: 100%; 

  .iframe {
    border-width: 0px;
    display: flex; 
    width: 100%; 
    height: 900px;
    flex-direction: column;
    flex-grow: 1;
  }
}*/

.project-footer {
  width: 100vw;
  position: fixed; /* relative */
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  height: 50px;
  bottom: 0px;
  background-color: rgba(185, 239, 255, 0.7);
  padding: 5px;

  background-clip: border-box;
  border: 1px solid #c2cfd6;

  transition: all 250ms linear;
  &.open {
    bottom: 50px;
    transition: all 250ms linear;
  }

  /*width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;


  position: fixed; /* absolute fixed* / 
  width: 100%;
  margin-right: auto;
  margin-left: auto;


  overflow: auto;
  float: left;
  display:inline-block;*/
}

.project-footer-inner {
  padding-left: 250px;
}

/*.btn-calculate {
  border-radius: 2px;
  //background-color: #1879b9;
  color: white;
  padding: 3px 20px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 15px;
  text-transform: uppercase;
}
.btn-save-project {
  border-radius: 2px;
  //background-color: #1879b9;
  color: white;
  padding: 3px 20px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 15px;
  text-transform: uppercase;
}
.btn-print-project {
  border-radius: 2px;
  //background-color: #1879b9;
  color: white;
  padding: 3px 20px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 15px;
  text-transform: uppercase;
}*/
</style>
